import { Subscribable } from "knockout";
import WCCSliderFullscreenItem from "../item/fullscreen/fullscreen.model";
import WCCSliderPage from "../models/page";
import WCCSliderBaseLayout, { WCCSliderBaseLayoutConfig, WCCSliderLayoutPageWidthCalculationConfig } from "./base";

export interface WCCSliderFullscreenLayoutContext<T> {
    page: WCCSliderPage<T, WCCSliderFullscreenItem<T>>
}

export interface WCCSliderFullscreenLayoutConfig { }
export interface WCCSliderFullscreenLayoutConfigFull<T> extends WCCSliderBaseLayoutConfig<T, WCCSliderFullscreenItem<T>>, WCCSliderFullscreenLayoutConfig { }

export default class WCCSliderFullscreenLayout<T> extends WCCSliderBaseLayout<T, WCCSliderFullscreenItem<T>, WCCSliderFullscreenLayoutContext<T>> {
    itemWidth: Subscribable<number>

    constructor(config: WCCSliderFullscreenLayoutConfigFull<T>) {
        super(config);

        this.itemWidth = this.width;

        queueMicrotask(() => {
            this.effects.register([
                ko.computed(() => this.updateItems()).extend({ deferred: true })
            ]);
        });
    }

    protected override getPageWidth(config: WCCSliderLayoutPageWidthCalculationConfig) {
        return this.width();
    }

    protected override getHeight() {
        const page = this.activePage();

        if (page != undefined) {
            const items = page.items();

            if (items.length > 0)
                return Math.max(...items.map(item => item.height() ?? 0));
        }
    }

    protected getContext(pages: WCCSliderPage<T, WCCSliderFullscreenItem<T>>[], page: WCCSliderPage<T, WCCSliderFullscreenItem<T>>, isFinal = false) {
        return { page }
    }

    protected buildItem(data: T) {
        return new WCCSliderFullscreenItem({ data: data });
    }

    protected canAddItem(item: WCCSliderFullscreenItem<T>, { page }: WCCSliderFullscreenLayoutContext<T>) {
        return page.items().length === 0;
    }

    private updateItems() {
        this.items().forEach(item => item.width(this.width()));
    }

    protected override getSpaceBetweenPages() {
        return 0;
    }    
}